export const SET_ERRORS = 'SET_ERRORS';
export const PUSH_ERRORS = 'PUSH_ERRORS';
export const SET_SUCCESS_MESSAGE = 'SET_SUCCESS_MESSAGE';
export const SET_MODAL_MESSAGE_STATUS = 'SET_MODAL_MESSAGE_STATUS';
